import React from 'react';
import { Box } from '@mui/material';
import useAuditImage from '../hooks/useAuditImage';

/**
 * Renders an audit recognition image that loads when scrolled into view.
 */
const LazyAuditImg = ({
  auditId,
  alt = '',
  anonymousImage = '/anonymous.webp',
  sx = {},
  imgSx = {},
  rootMargin = '200px',
  enabled = true,
  ...boxProps
}) => {
  const { ref, url } = useAuditImage(auditId, { enabled: enabled && Boolean(auditId), rootMargin });
  const src = url === undefined ? anonymousImage : (url || anonymousImage);

  return (
    <Box ref={ref} sx={sx} {...boxProps}>
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          ...imgSx,
        }}
      />
    </Box>
  );
};

export default LazyAuditImg;
